function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.006,
    viewBox: "0 0 18 18.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9068"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 887",
    d: "M710.427 385.094v2.865a3.82 3.82 0 0 1-3.819 3.819h-7.639a3.82 3.82 0 0 1-3.819-3.819v-7.639a3.82 3.82 0 0 1 3.819-3.819h2.865",
    transform: "translate(-694.149 -374.771)",
    style: {
      fill: "none",
      stroke: "#175664",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3747",
    transform: "translate(4.71)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 885",
    d: "m680.659 379.643 1.958 1.958a.316.316 0 0 1 0 .446l-8.086 8.075a.656.656 0 0 1-.4.193c-.474.05-1.566.175-2.066.235a.214.214 0 0 1-.24-.23c.032-.517.1-1.661.121-2.174a.675.675 0 0 1 .2-.445l8.07-8.058a.314.314 0 0 1 .443 0z",
    transform: "translate(-671.825 -377.136)",
    style: {
      fill: "#175664"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4422",
    width: 3.408,
    height: 2.165,
    rx: 0.333,
    transform: "rotate(45 5.44 13.133)",
    style: {
      fill: "#175664"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.51fa36ea.svg";
export { ForwardRef as ReactComponent };